export default {
  label: 'Invia a',
  counter: '{{current}} di {{max}}',
  default_badge: 'Predefinito',
  remove: 'Rimuovi {{email}}',
  add_back: 'Aggiungi di nuovo',
  empty: "Aggiungi almeno un'e-mail.",
  add_label: "Aggiungi un'e-mail",
  placeholder: 'nome@esempio.it',
  add: 'Aggiungi',
  hint: "Fino a {{max}} e-mail. Ognuna riceve un'e-mail separata.",
  hint_full: "Hai raggiunto il massimo per questa lista. Rimuovi un'e-mail per aggiungerne un'altra.",
  errors: {
    full: 'Puoi aggiungere al massimo {{max}} email.',
    invalid: "Inserisci un'e-mail come nome@esempio.it.",
    duplicate: "{{email}} è già nell'elenco.",
  },
};
